export interface GeoPoint {
  latitude: number;
  longitude: number;
}

// Coordonnées de Dole (fallback quand la géolocalisation est refusée ou indisponible)
export const DOLE_COORDS: GeoPoint = {
  latitude: 47.0978,
  longitude: 5.4928,
};


export async function reverseGeocode(point: GeoPoint): Promise<string | null> {
  const url = `/api/location/reverse-geocode?latitude=${point.latitude}&longitude=${point.longitude}`;

  try {
    const res = await fetch(url);
    if (!res.ok) return null;
    const data = await res.json();
    return extractCityDepartment(data);
  } catch {
    return null;
  }
}

export function getBrowserLocation(): Promise<GeoPoint> {
  return new Promise((resolve) => {
    if (typeof navigator === 'undefined' || !('geolocation' in navigator)) {
      resolve(DOLE_COORDS);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      () => {
        resolve(DOLE_COORDS);
      },
      {
        enableHighAccuracy: true,
        timeout: 8000,
        maximumAge: 300000,
      }
    );
  });
}


function extractCityDepartment(data: Record<string, unknown> | null): string | null {
  if (!data) return null;

  const address = (data.address ?? null) as Record<string, unknown> | null;
  if (!address) return (data.display_name as string) ?? null;

  const houseNumber = address.house_number ? String(address.house_number) : '';
  const road = address.road ?? address.pedestrian ?? address.footway ?? address.path;
  const city = address.city ?? address.town ?? address.village ?? address.municipality ?? address.hamlet;
  const department = address.county ?? address.state_district ?? address.state;

  const street = road ? (houseNumber ? `${houseNumber} ${road}` : String(road)) : houseNumber;
  const parts = [street, city, department].filter(Boolean);

  if (parts.length > 0) return parts.join(', ');
  return (data.display_name as string) ?? null;
}